module.exports = __webpack_public_path__ + "img/game_item_img1.4adaf628.png";